import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { GETUser, Update_User } from "../../../../../features/admin/auth/Slice";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

function Hotel_Profile() {
  const dispatch = useDispatch();

  // ✅ Redux selector
  const { getUserData } = useSelector((state) => state.autho.registration);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const password = watch("password");

  const [isEdit, setIsEdit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  // 🔹 Fetch user data on mount
  useEffect(() => {
    dispatch(GETUser());
  }, [dispatch]);

  // 🔹 Prefill form when user data arrives
  useEffect(() => {
    if (getUserData) {
      reset({
        name: getUserData.name || "",
        email: getUserData.email || "",
        contact_no: getUserData.contact_no || "",
        password: "",
        confirm_password: "",
      });
    }
  }, [getUserData, reset]);

  // 🔹 Update profile
  const onSubmit = async (data) => {
    const payload = {
      name: data.name,
      email: data.email,
      contact_no: data.contact_no,
    };
    if (data.password) payload.password = data.password;

    const res = await dispatch(Update_User(payload));

    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(GETUser()); // refresh data
      setIsEdit(false);
    }
  };

  return (
    <section className="Profile card_box">
      {/* Profile Image */}
      <div className="profile_img_holder">
        <div className="img_holder">
          <img
            src="/assets/images/portal/profile/student_img_1.webp"
            alt="profile"
            className="profile_img"
          />
        </div>
      </div>

      {/* Edit / Update Button */}
      <div className="d-flex justify-content-md-end justify-content-center mb-3">
        <Blue_border_button
          button_text={isEdit ? "Update Profile" : "Edit Profile"}
          onClick={isEdit ? handleSubmit(onSubmit) : () => setIsEdit(true)}
        />
      </div>

      {/* Form */}
      <div className="form_holder">
        <Form>
          <div className="row">
            {/* Name */}
            <div className="col-md-4 mb-3">
              <Form.Group className="form_field">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  disabled={!isEdit}
                  {...register("name", { required: "Name is required" })}
                />
                {errors.name && (
                  <Form.Text className="text-danger">
                    {errors.name.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Email */}
            <div className="col-md-4 mb-3">
              <Form.Group className="form_field">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  disabled={!isEdit}
                  {...register("email", { required: "Email is required" })}
                />
                {errors.email && (
                  <Form.Text className="text-danger">
                    {errors.email.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Contact */}
            <div className="col-md-4 mb-3">
              <Form.Group className="form_field">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  type="text"
                  disabled={!isEdit}
                  {...register("contact_no", {
                    required: "Contact number is required",
                  })}
                />
                {errors.contact_no && (
                  <Form.Text className="text-danger">
                    {errors.contact_no.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Password Fields (only editable in edit mode) */}
            {isEdit && (
              <>
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Password</Form.Label>
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        {...register("password")}
                      />
                      <FontAwesomeIcon
                        icon={showPassword ? faEye : faEyeSlash}
                        onClick={togglePasswordVisibility}
                        className="formPasswordIcon"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      {...register("confirm_password", {
                        validate: (value) =>
                          !watch("password") ||
                          value === password ||
                          "Passwords do not match",
                      })}
                    />
                  </Form.Group>
                </div>
              </>
            )}
          </div>
        </Form>
      </div>
    </section>
  );
}

export default Hotel_Profile;
